<template>
  <div v-if="pageFlag" class="gold-view rank-view">
    <!-- 头部导航栏 -->
    <div class="header">
      <div class="header-content">
        <div class="header-button header-back" @click="goBack()"></div>
        <h1>赛事排名</h1>
      </div>
    </div>
    <!-- 内容 -->
    <div class="view-scroller has-header has-header-tab ranking-content">
      <div class="conbacks">
        <!-- 顶部选项卡 -->
        <div class="ranking-content-tabs">
          <div
            v-for="(item,index) in rankTabArr"
            :key="index"
            class="ranking-content-tabs-item"
            :class="[index==rankNums?'activeTabs':'']"
            @click="changeTabs(item,index)"
          >{{ item.name }}</div>
        </div>
        <!-- 搜索产品 -->
        <div class="ranking-content-products">
          <div class="ranking-content-products-inputs">
            <div class="search-btns"></div>
            <input type="text" v-model="i_cj_name" placeholder="请输入产品名称和机构名称" @input="getInputSearch" />
            <div v-if="i_cj_name && JSON.stringify(selectObj)=='{}'" class="ranking-content-products-inputs-selects">
              <div
                v-for="(item,index) in searchArr"
                :key="index"
                class="ranking-content-products-inputs-selects-item"
                @click.stop="selectSearch(item)"
              >{{item.cj_name}}</div>
            </div>
          </div>
        </div>
        <!-- 下拉策略组 -->
        <div class="ranking-content-celue">
          <div class="ranking-content-celue-left">策略组</div>
          <div class="ranking-content-celue-right">
            <div class="ranking-content-celue-right-fir" @click="changeCelue">{{selectCelue['strategy_name']}}</div>
            <i class="icon-arrows" :class="[celueFlag?'icon-down':'icon-arrow']" @click="changeCelue"></i>
            <div v-if="celueFlag" class="ranking-content-celue-right-selects">
              <div
                v-for="(item,index) in orgOptions"
                :key="index"
                class="ranking-content-celue-right-selects-item"
                @click.stop="selectsCelue(item)"
              >{{ item.strategy_name }}</div>
            </div>
          </div>
        </div>
        <!-- 下方列表展示 -->
        <div class="list">
          <div class="list-title">
            <div class="title-tab" v-show="userType === '1'">产品名称</div>
            <div class="title-tab" v-show="userType === '2'">投资者名称</div>
            <div class="title-tab" v-show="userType === '1'">管理人名称</div>
            <div class="title-tab" v-show="rankType === '3'">综合得分</div>
            <!-- <div class="title-tab" v-show="rankType === '3'">赛事总分</div> -->
            <div class="title-tab">排名</div>
          </div>
          <div v-if="rankListData.length>0" class="content">
            <!-- loading为true时，不会触发滚动 -->
            <!-- infinite-scroll-immediate-check为true时，初始化会默认触发一次滚动 -->
            <!-- 初始化逻辑处理函数，可以忽略 -->
            <ul
              v-infinite-scroll="getMore"
              class="soll"
              infinite-scroll-disabled="loading"
              infinite-scroll-distance="20"
              infinite-scroll-immediate-check="false"
              infinite-scroll-listen-for-event="event"
            >
              <!-- v-infinite-scroll="loadMore"
                  infinite-scroll-disabled="loading"
              infinite-scroll-distance="1"-->
              <li v-for="(item, index) in rankListData" :key="index">
                <!-- 产品名称 -->
                <div v-show="userType === '1'">{{ item.prod_name }}</div>
                <!-- 管理人名称 -->
                <div v-show="userType === '1'">{{ item.prod_manager_name }}</div>
                <!-- 专业投资者参赛名称 -->
                <div v-show="userType === '2'">{{ item.player_name }}</div>
                <!-- 分数 -->
                <div v-show="rankType === '3'">{{ item.player_score }}</div>
                <!-- 排名 -->
                <div>{{ item.player_rank }}</div>
              </li>
            </ul>
            <div v-show="loading" style="text-align:center">正在加载...</div>
          </div>
          <div v-else class="no-data">
            <img src="../assets/no-data1.png" alt />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nativeService from '../services/common/nativeService.js'
import cjServices from '../services/cjServices.js'
import { Toast } from 'mint-ui'
export default {
  data() {
    return {
      //  顶部选项卡
      rankTabArr: [
        { name: '月排名', type: '2' },
        { name: '总排名', type: '3' }
      ],
      rankNums: 0,
      celueFlag: false, //控制策略组下拉
      searchArr: [], //搜索列表
      selectObj: {}, //选中后的对象
      orgOptions: [], //策略组
      selectCelue: {}, //选中的策略组
      rankListData: [], //下方列表数据
      i_page: 1, // 当前页
      i_perpage: 30, //每页行数
      //表单请求入参
      rankType: '2', //  1-周排名，2-月排名，3-总排名
      userType: '1', // 1 私募 2 专业
      i_cj_name: '', //  搜索名称,
      loading: false,
      pageFlag:false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getRaceProds()
      setTimeout(() => {
          this.pageFlag = true
      }, 200);
    },
    getInputSearch() {
      //   let value = e.target._value
      //   console.log(9999,e,value);
      this.selectObj = {}
      if (this.i_cj_name) {
        // 调用搜索接口
        this.getNameList(this.i_cj_name)
      } else {
        this.i_page = 1
        this.i_perpage = 30
        this.rankListData = []
        this.getRankList()
      }
    },
    selectSearch(item) {
      this.selectObj = item
      this.i_cj_name = item.cj_name
      this.i_page = 1
      this.i_perpage = 30
      this.rankListData = []
      this.getRankList()
    },
    getNameList(name) {
      // i_user_type：1-私募 2-专业投资者
      //  i_name：搜索名称
      const data = {
        i_user_type: this.userType,
        i_name: name.trim()
      }
      cjServices.selectNameList(this, data).then(res => {
        if (res.body && res.body.error_code == '0') {
          let results = res.body.results
          if (results.length > 0) {
            this.searchArr = results
            console.log(77777, this.searchArr)
          }
        } else {
          Toast({
            message: res.body.error_info,
            duration: 2000
          })
        }
      })
    },
    //   顶部选项卡点击事件
    changeTabs(item, index) {
      this.clearDatas()
      this.rankNums = index
      this.rankType = item.type
      this.getRankList()
    },
    changeCelue() {
      this.celueFlag = !this.celueFlag
    },
    // 获取策略组数据
    getRaceProds() {
      const data = {}
      cjServices.policyGroup(this, data).then(res => {
        if (res.body && res.body.error_code == '0') {
          let results = res.body.results
          if (results.length > 0) {
            this.orgOptions = results
            this.selectCelue = results[0]
          }
        } else {
          Toast({
            message: res.body.error_info,
            duration: 2000
          })
        }
        this.getRankList()
      })
    },
    //选中策略组
    selectsCelue(item) {
      this.celueFlag = !this.celueFlag
      this.selectCelue = item
      this.rankListData = []
      this.i_page = 1
      this.i_perpage = 30
      this.getRankList()
      console.log(9999, this.selectCelue, typeof this.celueFlag)
    },
    // 获取排名数据
    getRankList() {
      const data = {
        i_prod_record_num: this.selectObj.prod_record_num || '',
        i_user_type: this.userType,
        i_type: this.rankType,
        i_cj_name: this.selectObj.cj_name || '',
        i_prod_strategy: this.selectCelue.strategy_id,
        i_page: this.i_page,
        i_perpage: this.i_perpage
      }
      cjServices.rankList(this, data).then(res => {
        if (res.body && res.body.error_code == '0') {
          let results = res.body.results
          if (results.length > 0) {
            console.log(results, 222222)
            this.rankListData = [...this.rankListData, ...results]
          }
        } else {
          Toast({
            message: res.body.error_info,
            duration: 2000
          })
        }
      })
    },
    getMore() {
      this.loading = true //事先关闭防止重复触发
      setTimeout(() => {
        // ...逻辑处理
        this.i_page += 1
        // this.rankListData.push(...this.arrs);
        this.loading = false //再开启
        // console.log('this.rankListData', this.rankListData);
        this.getRankList()
      }, 500)
    },
    //初始化数据
    clearDatas() {
      this.i_page = 1
      this.i_perpage = 30
      this.rankListData = [] //下方列表
      this.selectObj = {} //搜索选中的对象
    },
    goBack() {
      nativeService.routerRedirect(-1, this)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'sass/gold/common.scss';
@import 'sass/gold/newRanking.scss';
</style>
